import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import Header from '../Header/Header';
import { SpreadsheetContainerRd } from '../../Pages/SpreadsheetContainer/SpreadsheetContainerRd';
import { SpreadsheetContainer } from '../../Pages/SpreadsheetContainer/SpreadsheetContainer';
import DocumentDataConflictModal from '../ConflictModal';
import OfflineStatus from '../OfflineStatus/OfflineStatus';
import { hasCachedDocument } from '../../utils/documentCache';

const MainLayout = () => {

    const { isReadOnly, isConflictModalVisible, setIsConflictModalVisible, conflictPreviewVerion, isTemplateDocument } = useDocument();
    const [contentLoading, setContentLoading] = useState(true);
    const { id } = useParams();

    // A cached document paints instantly, so its chrome (Header / OfflineStatus)
    // must show immediately too - it cannot wait for `contentLoading` to flip,
    // which only happens once the background content fetch resolves.
    const isDocumentCached = useMemo(
        () => !isTemplateDocument && hasCachedDocument(id),
        [id, isTemplateDocument]
    );
    const showChrome = !contentLoading || isDocumentCached;

    return (
        <>
            {isReadOnly ? (
                <>
                    {!conflictPreviewVerion && <Header fileDisplay={false} />}
                    <OfflineStatus />
                    <SpreadsheetContainerRd
                        contentLoading={contentLoading}
                        setContentLoading={setContentLoading}
                    />
                </>
            ) : (
                <>
                    {showChrome && <Header fileDisplay={true} />}
                    {showChrome && <OfflineStatus />}
                    <SpreadsheetContainer
                        contentLoading={contentLoading}
                        setContentLoading={setContentLoading}
                    />
                    <DocumentDataConflictModal
                        isConflictModalVisible={isConflictModalVisible}
                        setIsConflictModalVisible={setIsConflictModalVisible}
                    />
                </>
            )}

        </>
    )
}

export default MainLayout;